import React, {useState} from 'react';
import {makeStyles, Stepper, Step, StepLabel, Typography, Button} from '@material-ui/core/';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import DatosIdentidad from '../DatosIdentidad'
import DatosCiudadanoRENAP from '../DatosCiudadanoRENAP'
import Homonimos from '../Homonimos'
import DatosCiudadanoResumen from '../DatosCiudadanoResumen'
import DatosCiudadanoRENAPRechazarSolicitud from '../../RechazarSolicitudEmpadronamiento/DatosCiudadanoRENAP'
import {useStyles} from './style';

const StepperForm = (props) => {
    
    const classes = useStyles(),
        steps =  ['Datos de Identidad','Asignar Residencia Electoral', 'Homónimos', 'Empadronar ciudadano', 'Rechazar Solicitud'],
        getStepContent = (step) => {
            switch (step) {
                case 0:
                    return <DatosIdentidad cerrarDialogo={props.cerrarDialogo} fotosVieneVacio={props.fotosVieneVacio} mensajeFotosVieneVacio={props.mensajeFotosVieneVacio}/>;
                case 1:
                    return <DatosCiudadanoRENAP cerrarDialogo={props.cerrarDialogo} actualizarTabla={props.actualizarTabla} usuarioEstaEmpadronado={props.usuarioEstaEmpadronado}
                        nroBoleta={props.nroBoleta} open={props.open} ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                        datosResidenciaExtranjeroRenapSeleccionado={props.datosResidenciaExtranjeroRenapSeleccionado}
                    />;
                case 2:
                    return <Homonimos cerrarDialogo={props.cerrarDialogo} />;
                case 3:
                    return <DatosCiudadanoResumen cerrarDialogo={props.cerrarDialogo} open={props.open} actualizarTabla={props.actualizarTabla}
                        datosResidenciaExtranjeroRenapSeleccionado={props.datosResidenciaExtranjeroRenapSeleccionado}
                    />;
                case 4:
                    return <DatosCiudadanoRENAPRechazarSolicitud cerrarDialogo={props.cerrarDialogo} open={props.open} ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                        actualizarTabla={props.actualizarTabla}
                    />;
                default:
                    return 'Unknown step';
            }
        };

    return (
        <div className={classes.root}>
            <Stepper className={classes.Margenes} activeStep={props.step}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    if(props.rechazarSolicitud){
                        if (index === 1 || index === 2 || index === 3) {
                            stepProps.completed = false;
                        }
                    }
                    return (
                    <Step key={label} {...stepProps}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                    );
                })}
            </Stepper>
                {props.step === steps.length ? (
                    ""
                ) : (
                    <div>
                        {getStepContent(props.step)}
                    </div>
                )}
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StepperForm);